<template>
    <div class="mt-3">
        <div class="row">
            <div class="col-sm-4 modspec_font14">Ceiling</div>
        </div>

        <div class="row">
            <div class="col-sm-1"></div>
            <div class="col-sm-11">
                <!------------------------------->
                <div class="row mt-2">
                    <div class="col-sm-4 modspec_font14">Profile</div>
                    <div class="col-sm-8">
                        <select class="form-select">
                            <option value="Flat">Flat</option>
                            <option value="Raked">Raked</option>
                            <option value="Raked/Flat">Raked/Flat</option>
                        </select>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-sm-4 modspec_font14">Insolation</div>
                    <div class="col-sm-8">
                        <input class="form-check-input" id="ceilingBulk" type="checkbox"> <label
                            class="form-check-label modspec_font10" for="ceilingBulk"> Bulk</label>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-sm-4">
                    </div>
                    <div class="col-sm-2 modspec_font10">
                        <input class="form-check-input" id="ceilingDescription" type="checkbox"> <label
                            class="form-check-label modspec_font10" for="ceilingDescription"> Description</label>
                    </div>
                    <div class="col-sm-3">
                        <input type="text" class="form-control" placeholder="i.e Fletcher HD" />
                    </div>
                    <div class="col-sm-1 modspec_font10">R-val</div>
                    <div class="col-sm-2">
                        <select class="form-select">
                            <option value="">1.0</option>
                        </select>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-sm-4 modspec_font14">Lining</div>
                    <div class="col-sm-8">
                        <select class="form-select">
                            <option value="">As per drawings</option>
                        </select>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-sm-2 modspec_font14">Framing</div>
                    <div class="col-sm-2">
                        <select class="form-select">
                            <option value="">Metal</option>
                        </select>
                    </div>
                    <div class="col-sm-1 modspec_font10">Purlins:</div>
                    <div class="col-sm-2">
                        <select class="form-select">
                            <option value="">LC15019</option>
                        </select>
                    </div>
                    <div class="col-sm-1"></div>
                    <div class="col-sm-2 modspec_font10">Ctrs(mm)</div>
                    <div class="col-sm-2">
                        <select class="form-select">
                            <option value="">900</option>
                        </select>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-sm-4">
                        <button class="btn btn-primary">Add Detail/Note +</button>
                    </div>
                </div>
                <!------------------------------->
            </div>
        </div>


    </div>
</template>
<script>
export default {
    name: "cd-ceiling",
    data: function () {
        return {
            ceiling: {  },
        }
    },
    mounted() {

    },
    methods: {
        test(){
            this.ceiling = {  };
        },

    },
}
</script>
<style></style>